<template>

    <div class="file_uploader">
        <notifText class="uploader_notice_box">
            {{ $t("components.shared.filesUpload.fileUploaderNotice") }}
            <strong class="uploader_warning">{{ $t("components.shared.filesUpload.fileUploaderAlertNotice") }}</strong>

        </notifText>
        <vueDropzone ref="myVueDropzone"
            id="dropzone"
            :options="dropzoneOptions"
            :useCustomSlot="true"
            @vdropzone-complete="onFileComplete"
            @vdropzone-success="onFileSuccess"
            @vdropzone-error="onFileError">

            <i class="zmdi zmdi-cloud-upload"></i>
            <div class="subtitle">{{ $t("components.shared.filesUpload.dragNotice") }}</div>
            <h3 class="dropzone-custom-title">{{ $t("components.shared.filesUpload.clickNotice") }}</h3>
        </vueDropzone>
    </div>

</template>


<script>
import vue2Dropzone from 'vue2-dropzone'

export default {
    name: 'FilesUploader',
    props: {
        maxFileSize: {
            default: 2
        }
    },
    components: {
        vueDropzone: vue2Dropzone
    },
    computed: {
        uploadUrl(){
            return process.env.VUE_APP_AXIOS_BASE_URL + this.$store.sightApiBaseUrl
        }
    },
    data(){
        return {
            fileList: [],
            dropzoneOptions: {
                url: process.env.VUE_APP_AXIOS_BASE_URL + this.$store.sightApiBaseUrl + "document_files",
                headers: { Authorization: `Bearer ${localStorage.getItem('jwt')}` },
                createImageThumbnails: false,
                maxFilesize: this.maxFileSize,
                timeout: 0,
                dictDefaultMessage: this.$t("components.shared.filesUpload.dictDefaultMessage"),
                dictFallbackMessage: this.$t("components.shared.filesUpload.dictFallbackMessage"),
                dictFallbackText: this.$t("components.shared.filesUpload.dictFallbackText"),
                dictFileTooBig: this.$t("components.shared.filesUpload.dictFileTooBig"),
                dictInvalidFileType: this.$t("components.shared.filesUpload.dictInvalidFileType"),
                dictResponseError: this.$t("components.shared.filesUpload.dictResponseError"),
                dictCancelUpload: this.$t("components.shared.filesUpload.dictCancelUpload"),
                dictUploadCanceled: this.$t("components.shared.filesUpload.dictUploadCanceled"),
                dictCancelUploadConfirmation: this.$t("components.shared.filesUpload.dictCancelUploadConfirmation"),
                dictRemoveFile: this.$t("components.shared.filesUpload.dictRemoveFile"),
                dictMaxFilesExceeded: this.$t("components.shared.filesUpload.dictMaxFilesExceeded")
            }
        }
    },
    methods: {
        onFileComplete(file, response){
            console.log("File upload completed")
        },
        onFileSuccess(file, response){
            this.fileList.push(response)
            this.$emit("fileUploaded", this.fileList)
        },
        onFileError(file, message, xhr){
            console.log(message)
        }
    }
}

</script>

<style lang="scss"  >
.uploader_notice_box{
    margin-bottom: 8px;
}
</style>